import React, { Component } from "react";
import { Fade } from "react-reveal";
import Button from "../../components/button/Button";
import AddressImg from "../../pages/contact/AddressImg";
import { contactPageData } from "../../portfolio.js";
import "../../pages/contact/ContactComponent.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

const ContactData = contactPageData.contactSection;
const emailSection = contactPageData.blogSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;

// Section title keys mapping
const sectionTitleMap = {
  Email: "email_label",
  Location: "location",
  "Primary Contact": "phone_label",
};

const ContactSectionContent = ({ theme, language }) => {
  return (
    <div className="contact-main">
      <div className="basic-contact">
        {/* Main Contact Header */}
        <Fade bottom duration={1000} distance="40px">
          <div
            className="contact-heading-div"
            style={{ maxWidth: "900px", margin: "0 auto 40px" }}
          >
            <div className="contact-heading-text-div" style={{ width: "100%" }}>
              <h1
                className="contact-heading-text"
                style={{ color: theme.text }}
              >
                {getTranslation(language, "contact_us_heading")}
              </h1>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {getTranslation(language, "contact_desc")}
              </p>
            </div>
          </div>
        </Fade>

        {/* Email Section */}
        <Fade bottom duration={1000} distance="40px">
          <div
            className="blog-heading-div"
            style={{ maxWidth: "900px", margin: "0 auto 30px" }}
          >
            <div className="blog-heading-text-div" style={{ width: "100%" }}>
              <h2 className="blog-heading-text" style={{ color: theme.text }}>
                {getTranslation(
                  language,
                  sectionTitleMap[emailSection["title"]] || "email_label"
                )}
              </h2>
              <p
                className="blog-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {emailSection["subtitle"]}
              </p>
              <div className="blogsite-btn-div">
                <Button
                  text={getTranslation(language, "send")}
                  newTab={true}
                  href={emailSection.link}
                  theme={theme}
                />
              </div>
            </div>
          </div>
        </Fade>

        {/* Address and Phone Section */}
        <Fade bottom duration={1000} distance="40px">
          <div
            className="address-heading-div"
            style={{ maxWidth: "900px", margin: "0 auto" }}
          >
            <div className="address-heading-text-div" style={{ width: "100%" }}>
              <h2
                className="address-heading-text"
                style={{ color: theme.text }}
              >
                {getTranslation(
                  language,
                  sectionTitleMap[addressSection["title"]] || "location"
                )}
              </h2>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {addressSection["subtitle"]}
              </p>

              <h2
                className="address-heading-text"
                style={{ color: theme.text, marginTop: "30px" }}
              >
                {getTranslation(
                  language,
                  sectionTitleMap[phoneSection["title"]] || "phone_label"
                )}
              </h2>
              <p
                className="contact-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {phoneSection["subtitle"]}
              </p>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

class ContactSection extends Component {
  render() {
    const theme = this.props.theme;
    const language = this.props.language;
    return <ContactSectionContent theme={theme} language={language} />;
  }
}

// Wrapper component to inject language from context
function ContactSectionWithLanguage(props) {
  const { language } = useLanguage();
  return <ContactSection {...props} language={language} />;
}

export default ContactSectionWithLanguage;
